/**
 * Nuture · Floating CTA
 * ---------------------------------------------------------------------------
 * Comportamento padrão de toda barra/botão flutuante do tema: o elemento
 * inteiro é clicável e faz exatamente o que o CTA dele faz.
 *
 * Contrato — dois atributos no markup do block, zero JS por block:
 *   [data-nuture-floating-cta]         → o container flutuante
 *   [data-nuture-floating-cta-target]  → o CTA de verdade dentro dele
 *
 * O clique fora do CTA é encaminhado com cta.click(), então o comportamento é
 * o do próprio CTA — <a> navega, <button> dispara os listeners que já existem
 * (RF-004 anchor/direct/drawer, RF-007). Nada é reimplementado aqui, o que
 * mantém uma única fonte de verdade por barra.
 *
 * Acessibilidade: o CTA continua sendo o controle. Ele é quem recebe foco,
 * teclado e nome acessível — o container não vira botão nem ganha role, é só
 * uma área de clique a mais para o mouse/toque.
 */
(function () {
  if (window.nutureFloatingCta) return;
  window.nutureFloatingCta = true;

  var BAR = '[data-nuture-floating-cta]';
  var TARGET = '[data-nuture-floating-cta-target]';

  // Qualquer coisa que já responde a clique sozinha manda em si mesma: clicar
  // na miniatura que é link não pode virar clique no botão de comprar.
  var INTERACTIVE =
    'a[href], button, input, select, textarea, label, summary, video, audio, [role="button"], [role="link"], [contenteditable="true"]';

  /** Selecionar o texto da barra não é clicar na barra. */
  function isSelectingText() {
    var selection = window.getSelection && window.getSelection();
    return !!selection && !selection.isCollapsed && String(selection).trim() !== '';
  }

  function isDisabled(cta) {
    return cta.disabled === true || cta.getAttribute('aria-disabled') === 'true';
  }

  document.addEventListener('click', function (event) {
    // No theme editor o clique serve pra selecionar o block. Deixa a área
    // extra de lado ali — o CTA em si continua funcionando pra teste.
    if (window.Shopify && window.Shopify.designMode) return;

    if (event.defaultPrevented) return;

    // Ctrl/Cmd/Shift-clique é "abrir em outra aba/janela", e isso só o <a> de
    // verdade resolve. Encaminhar aqui roubaria a intenção do usuário.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var bar = target.closest(BAR);
    if (!bar) return;

    var cta = bar.querySelector(TARGET);
    if (!cta || isDisabled(cta)) return;

    // Clique no próprio CTA (ou em ícone/label dentro dele): comportamento
    // nativo, sem encaminhar — senão o clique aconteceria duas vezes.
    if (cta.contains(target)) return;

    if (target.closest(INTERACTIVE)) return;
    if (isSelectingText()) return;

    cta.click();
  });
})();
